import httpUrls from './HttpUrlConfig.js'
import Element from 'element-ui'
import main from '../../main.js'
import axios from "axios";
const HttpConfig = {apiConfig: {mainUrl: '', cookies: false,header: []}};
const urlConfig = httpUrls
export default HttpConfig

//http 针对返回的response进行初始化设置(可以在此处对业务status进行相关配置)
HttpConfig.initBody = function(res){
  if (res.data.code === '200') {
    return {result: 'success', code: 100, body: res.data, url: res.config.url};
  } else if (res.data.code === '10017') {
    return {result: 'success', code: 100, body: res, url: res.config.url};
  } else if (res.data.code === '10030') {
    return {result: 'success', code: 100, body: res, url: res.config.url};
  } else if(res.data.status_code === 100){
		return {result: 'success', code: res.data.status_code+"", body: res.data, url: res.config.url};
	}else{
		return {result: 'fail', code: res.data.status_code+"", body: res.data, url: res.config.url};
	}

};

//设置针对http status和业务自定义的status进行集中处理回调
HttpConfig.codeForHandler = [];
HttpConfig.codeForHandler.push({"520" : function(e){
	Element.Message(e.body.error_msg);
}});
HttpConfig.codeForHandler.push({"500" : function(e){
  // Element.Message(e.body.error_msg);
  // console.log(e)
  if(e.url === "/v1/inspectionroute/update") {
    Element.Message.error('请配置频率')
  }else{
    Element.Message('服务繁忙，请稍后再试')
  }
}});
HttpConfig.codeForHandler.push({"510" : function(e){
	Element.Message(e.body.error_msg);
}});
HttpConfig.codeForHandler.push({"530" : function(e){
        Element.Message(e.body.error_msg);
    }});
HttpConfig.codeForHandler.push({"100" : function(e){
	//此处返回true时，该数据将继续分发给http请求处的then回调方法
	return true;
}});
HttpConfig.codeForHandler.push({"200" : function(e){
	Element.Message(e.body.error_msg);
}});
HttpConfig.codeForHandler.push({"420" : function(e){
	Element.Message(e.body.error_msg);
}});
HttpConfig.codeForHandler.push({"405" : function(e){
	Element.Message('请重新登录');
	main.$router.push({ path: '/login' });
	main.componentsMoudel.clearLocalStorage();
}});
HttpConfig.codeForHandler.push({ "-3" : function(e){
	Element.Message(e.body.error_msg);
	console.error(e.body.error_msg);
}});
HttpConfig.codeForHandler.push({ "400" : function(e){
  // 当登录失败时在本地存储一个状态 失败次数过多限制登录
  // console.log(e)
  if(e.url === "/v1/login/toLogin") {
    let num = JSON.parse(localStorage.getItem('num'))
      if(num === 5) {
        Element.Message('操作过于频繁，请稍后再试')
      } else {
        num += 1
        // console.log(num)
        localStorage.setItem('num', num)
        localStorage.setItem('time', Date.parse(new Date()))
        Element.Message(e.body.error_msg);
      }
	} else if(e.url === '/v1/task/get_my_task') {
		return {result: 'success', code: 400, body: e.body, url: e.url};
	} else {
		Element.Message(e.body.error_msg);
	}
  // console.log(e)
}});

//设置访问加载框
HttpConfig.loadCallBack = {
	openLoading: function(option){
		const loading = Element.Loading.service({
						lock: true,
						text: 'Loading',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
		return loading;
	},
	endLoading: function(option, operating){
		setTimeout(() => {
			operating.close();
		},500)
	}
}

HttpConfig.httpAccessFn = function(config, url, data,success, error){
	axios({
		url: url,
		method: config.method,
		data: data,
		headers: config.header,
		withCredentials: config.cookies,
	}).then(success).catch(error);
}
